import React from "react";
import { observer } from "mobx-react";
import styles from "./Notifications.scss";
import { useStores } from "netbank-shared/src/hooks";
import { INotification } from "netbank-shared/src/libs/models/Content/Notification";
import { IGenericContentLink } from "netbank-shared/src/libs/models/Content/ContentLink";
import { Notification } from "./Notification";

const order = { error: 1, important: 2, information: 3 };

export const Notifications = observer(() => {
  const { contentStore, uiStore, customerPersistentStore } = useStores();

  const { viewedNotifications, addToViewedNotifications, isNotificationViewed } = customerPersistentStore;
  const { isMobile } = uiStore;
  const { currentPage } = contentStore;

  const notifications = currentPage?.notifications;

  if (!notifications || notifications.length <= 0) {
    return null;
  }

  if (notifications.length === viewedNotifications.length) {
    return null;
  }

  const handleClose = (notification: IGenericContentLink<INotification>) => {
    if (notification.contentLink?.guidValue && !isNotificationViewed(notification)) {
      addToViewedNotifications(notification);
    }
  };

  return (
    <div className={styles.notificationsWrapper}>
      {notifications
        .filter((notification) => !isNotificationViewed(notification))
        .slice()
        .sort((a, b) => order[a.level] - order[b.level])
        .map((notification: IGenericContentLink<INotification>) => {
          const content = isMobile ? notification.mobileContent : notification.content;

          const showLink = isMobile || (!isMobile && !notification.hideLinkOnDesktop);

          const link = notification?.linkItem?.[0]?.link?.[0] || notification.link?.[0];

          const trackingCategory = notification?.linkItem?.[0].trackingCategory;
          const trackingAction = notification?.linkItem?.[0].trackingAction;

          return (
            <Notification
              key={notification.contentLink?.guidValue}
              level={notification.level}
              content={content}
              header={notification.header}
              link={showLink ? link : undefined}
              trackingCategory={trackingCategory}
              trackingAction={trackingAction}
              onClose={() => handleClose(notification)}
            />
          );
        })}
    </div>
  );
});
